import { FormikHelpers } from "formik";
import { useCreateArea } from "./api/createArea";
import AreaForm from "./AreaForm";;


const CreateArea = ({handleCloseModal}: CreateAreaProps)  => {
  const createAreaMutation = useCreateArea({data: {}});

  const initialValues: IPostNewArea = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewArea, { setSubmitting }: FormikHelpers<IPostNewArea>): Promise<void> => {
    try {
      await createAreaMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AreaForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateAreaProps {
  handleCloseModal: () => void;
}

export default CreateArea;